module.exports = __webpack_public_path__ + "img/empresa_vivo_faturas_envio_clientes2.c3088631.jpg";